// Insights/actionTypesSagas.js
import * as t from './actionTypesSagas';

export const newAdminActionSagas = payload => ({
  type: t.NEW_ADMIN_SAGAS,
  payload,
});
